import { useNavigate } from 'react-router-dom';

import { appColors, SIDEBAR_COLLAPSED_WIDTH } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { ImageTextBox } from '@backrs_ui/grow-ui/src/components/Header/ImageTextBox';

import { Box, SxProps, Theme, Button } from '@mui/material';

const INTRO_PAGE_STRINGS = appStrings.modules.intro;

const HEADER_IMAGE = '/images/blueprint-logo-small.png';

type BlueprintStartHereProps = Readonly<{
  id: string;
  isSlideActive: boolean;
  onSlideClick: () => void;
}>;

export const BlueprintStartHere = ({
  id,
  isSlideActive,
  onSlideClick,
}: BlueprintStartHereProps) => {
  const navigate = useNavigate();

  return (
    <Box onClick={onSlideClick} sx={containerStyle} data-scroll-id={id}>
      <Box sx={imageTextBoxContainerStyle}>
        <ImageTextBox
          id={id}
          body={[
            INTRO_PAGE_STRINGS.header,
            <Box sx={buttonContainerStyle} key="button">
              <Button
                variant="contained"
                sx={buttonStyle}
                onClick={isSlideActive ? () => navigate(APP_ROUTE.SURVEY) : onSlideClick}
              >
                {INTRO_PAGE_STRINGS.buttonTitle}
              </Button>{' '}
            </Box>,
          ]}
          imageSrc={HEADER_IMAGE}
          key={isSlideActive ? 'active' : 'inactive'}
        />
      </Box>
    </Box>
  );
};

const containerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  pt: { xs: '40vw', sm: '96px' },
  ml: {
    xs: '10vw',
    sm: `-${SIDEBAR_COLLAPSED_WIDTH / 2}px`,
  },
  '@media (max-height: 700px)': {
    pb: '56px',
  },
  boxSizing: 'border-box',
  position: 'relative',
  whiteSpace: 'pre-wrap',
  height: '100svh',
  width: {
    xs: '70vw',
    sm: '100vw',
  },
  paddingRight: { xs: '16px', sm: '32px' },
} as const;

const buttonStyle: SxProps<Theme> = {
  borderRadius: '2rem',
  backgroundColor: appColors.color.blue1,
  paddingX: '4rem',
  textTransform: 'none',
  fontWeight: 'bold',
  fontSize: 20,
  width: '100%',
  mt: 3,
  '@media (max-width: 700px)': {
    fontSize: '12pt',
    paddingX: '3rem',
  },
} as const;

const buttonContainerStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  width: { sm: 'fit-content' },
  minWidth: { sm: '250px' },
} as const;

const imageTextBoxContainerStyle: SxProps<Theme> = {
  maxWidth: {
    xs: '90%',
    sm: '330px',
  },
  minWidth: {
    xs: 'unset',
    sm: 'unset',
  },
  marginBottom: { xs: '2rem', sm: 'unset' },
} as const;
